import script from "./MainIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MainIndex.vue?vue&type=script&setup=true&lang=js"

import "./MainIndex.vue?vue&type=style&index=0&id=1d9e7628&scoped=true&lang=scss"
import "./MainIndex.vue?vue&type=style&index=1&id=1d9e7628&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9e7628"]])

export default __exports__